import React, { useState } from 'react';
import styled from 'styled-components/macro';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { white, brand, brandLighter, error } from 'variables/colors';
import { fontWeightBold } from 'variables/font';
import { borderRadius, transition } from 'variables/general';
import { FlexCenterVertical } from 'styles/flexbox';
import StatusDropdown from 'components/StatusDropdown';

const getBackgroundColor = (label) => {
  switch (label) {
    case 'Draft':
      return '#fdcc86';
    case 'Confirmed':
      return brandLighter;
    case 'Completed':
      return '#81e196';
    case 'Cancelled':
      return '#ffb3ba';
    case 'Late Cancelled':
      return error;
    default:
      return brand;
  }
};

const Tag = styled(FlexCenterVertical)`
  padding: 0.75em;
  background-color: ${({ label }) => getBackgroundColor(label)};
  border-radius: ${borderRadius};

  &:hover {
    opacity: 0.7;
  }
`;

const Component = styled(FlexCenterVertical)`
  position: relative;
  color: ${white};
  font-weight: ${fontWeightBold};
  font-size: ${({ size }) => (size === 'small' ? '0.625em' : '.75em')};
  cursor: pointer;
  transition: ${transition};

  .MuiSvgIcon-root {
    transform: rotate(0);
    transition: ${transition};
  }

  &.active {
    .MuiSvgIcon-root {
      transform: rotate(-180deg);
    }
  }
`;

const StatusTag = ({ label, setStatusTag }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleStatusChange = async (value) => {
    setStatusTag(value);
  };

  return (
    <Component
      label={label}
      className={menuOpen && 'active'}
      onClick={toggleMenu}
    >
      <Tag label={label}>
        {label}
        <KeyboardArrowDownIcon fontSize="small" />
      </Tag>

      {menuOpen && (
        <StatusDropdown
          handleClickAway={toggleMenu}
          handleStatusChange={handleStatusChange}
        />
      )}
    </Component>
  );
};

export default StatusTag;
